/**
 * Cross-cutting capacity filter utility.
 *
 * Capacities that are paused or of unknown type are excluded from all default
 * views. The global toggle (useCapacityFilterStore) overrides this when the
 * user explicitly wants to see them.
 */

export interface FilterableCapacity {
  capacityType?: string;
  capacity_type?: string;
  currentState?: string;
  isPaused?: boolean;
  is_paused?: boolean;
  capacity_is_active?: boolean;
}

/** Returns true when a capacity should be hidden in the default view. */
export function isExcludedCapacity(c: FilterableCapacity): boolean {
  const type = (c.capacityType ?? c.capacity_type ?? '').toLowerCase();
  const paused =
    c.isPaused === true ||
    c.is_paused === true ||
    c.currentState === 'paused' ||
    c.capacity_is_active === false;
  return type === 'unknown' || paused;
}

/** Filters an array, respecting the global showPausedUnknown toggle. */
export function filterCapacities<T extends FilterableCapacity>(
  capacities: T[],
  showPausedUnknown: boolean,
): T[] {
  if (showPausedUnknown) return capacities;
  return capacities.filter((c) => !isExcludedCapacity(c));
}
